export const ADD_FLEX_TICKETS = 'ADD_FLEX_TICKETS';
export const REMOVE_FLEX_TICKETS = 'GET_FLEX_TICKETS_FAILURE';

export const ADD_PRODUCTS_TO_CART = 'ADD_PRODUCTS_TO_CART';
export const REMOVE_PRODUCT_TO_CART = 'REMOVE_PRODUCT_TO_CART';
export const MERGE_LOCAL_AND_REMOTE_CART = 'MERGE_LOCAL_AND_REMOTE_CART';

export const TOGGLE_FOOTER = 'TOGGLE_FOOTER';
export const PASSES_CART = 'PASSES_CART';
export const TOGGLE_WEEKDAY_SWITCH = 'TOGGLE_WEEKDAY_SWITCH';

export const RESTORE_CART_PRODUCTS = 'RESTORE_CART_PRODUCTS';

export const SET_CURRENT_TICKET = 'SET_CURRENT_TICKET';

export const SET_DAYS_QUANTITY = 'SET_DAYS_QUANTITY';
export const SET_FIX_TICKETS = 'SET_FIX_TICKETS';
export const REMOVE_FIX_TICKETS = 'REMOVE_FIX_TICKETS';
export const SET_SELECTED_FIX_EVENT = 'SET_SELECTED_FIX_EVENT';
export const REMOVE_SELECTED_FIX_EVENT = 'REMOVE_SELECTED_FIX_EVENT';
export const SELECT_DEFAULT_FIX_TICKET = 'SELECT_DEFAULT_FIX_TICKET';
export const SET_WEEKDAYS_ONLY = 'SET_WEEKDAYS_ONLY';

export const ADD_TODAY_PRODUCTS = 'ADD_TODAY_PRODUCTS';

export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';

export const SET_STOCK_DATES = 'SET_STOCK_DATES';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js